import React from 'react';
import { IonPage, IonContent, IonButton, IonText, IonSpinner } from '@ionic/react';
import type { ShareLevel } from '../../domain/DeviceShare';
import { useJoinDevice } from '../../application/use-cases/deviceShares/useJoinDevice';
import BrandMark from '../components/BrandMark';
import './Login.css';

const levelLabel: Record<ShareLevel, string> = { view: 'ver', control: 'ver y controlar' };
const lotLevelLabel: Record<ShareLevel, string> = { view: 'ver', control: 'ver y editar' };

const JoinDevice: React.FC = () => {
  const { status, error, result, history } = useJoinDevice();

  return (
    <IonPage>
      <IonContent fullscreen className="login-content">
        <div className="login-container">
          <div className="login-logo">
            <BrandMark />
            <h1>DomIoT</h1>
            <p>{result?.kind === 'lot' ? 'Lote compartido' : 'Te compartieron'}</p>
          </div>

          {status === 'accepting' && (
            <div className="ion-text-center">
              <IonSpinner color="primary" />
            </div>
          )}

          {status === 'done' && result && (
            <>
              {result.kind === 'lot' ? (
                <>
                  <IonText>
                    <p style={{ textAlign: 'center', fontSize: 14, lineHeight: 1.6 }}>
                      {result.ownerName} te compartió el lote <strong>{result.lotName}</strong> ({lotLevelLabel[result.level]}), con
                      sus estaciones.
                    </p>
                  </IonText>
                  <IonButton expand="block" onClick={() => history.replace(`/app/lots/${result.lotId}`)}>
                    Ver lote
                  </IonButton>
                </>
              ) : (
                <>
                  <IonText>
                    <p style={{ textAlign: 'center', fontSize: 14, lineHeight: 1.6 }}>
                      {result.ownerName} te compartió <strong>{result.deviceName}</strong> ({levelLabel[result.level]}).
                    </p>
                  </IonText>
                  <IonButton expand="block" onClick={() => history.replace(`/app/devices/${result.deviceId}`)}>
                    Ver estación
                  </IonButton>
                </>
              )}
            </>
          )}

          {status === 'error' && (
            <>
              <IonText color="danger">
                <p style={{ textAlign: 'center', fontSize: 14 }}>{error}</p>
              </IonText>
              <IonButton expand="block" fill="clear" routerLink="/app/devices">
                Ir a mis estaciones
              </IonButton>
            </>
          )}
        </div>
      </IonContent>
    </IonPage>
  );
};

export default JoinDevice;
